export const cloudinaryUrl = (opts, type = 'image', asset) => {
  if (!asset || asset === '') return;
  const resourceType = type === 'image' ? 'image' : 'video';

  // Just need to validate that asset is a string
  // we do get object on some ocassions
  const initialUrl = typeof asset !== 'string' ? asset.url : asset;

  if (!initialUrl) return;

  let url = initialUrl.split(`/${resourceType}/upload`);
  let [domain, pathname] = url;

  if (!domain || !pathname) return asset;

  // let domain = new URL(asset.url || asset);
  // // const pathname = domain.pathname.replace(`${resourceType}/upload/`, '');
  // domain = domain.hostname;

  const options = {
    ...opts,
    resourceType,
    type: 'upload',
  };

  let transformations = [];
  for (let [transformation, value] of Object.entries(options)) {
    switch (transformation) {
      case 'secure':
      case 'resourceType':
      case 'type':
        // Ignore, because they are part of the URL
        break;
      case 'background':
      case 'crop':
      case 'fetch_format':
      case 'gravity':
      case 'height':
      case 'quality':
      case 'width':
      case 'x':
      case 'y':
        if (value) {
          transformations.push(transformation[0] + '_' + value);
        }
        break;
      default:
        throw new Error('Unhandled image transformation ' + transformation);
    }
  }
  transformations.sort();

  return `${domain}/${options.resourceType}/${
    options.type
  }/${transformations.join(',')}${pathname}`;
};
